import React, { useState, useEffect, useCallback } from "react";
import OurNetworkForm from "./Forms/OurNetworkForm";
import { urls } from "../../config/constants";
import { image2svg } from "../../utilsfunctions/Svg";
import AOS from "aos";
import "aos/dist/aos.css";
import { CommonApi } from "../../config/api";
import { defaultHeader, toastError, validateJsonString } from "../../services/CommonFunction";
import { callApi } from "../../services/ApiService";
import MoveCursorToTop from "../../services/MoveCursorToTop";
import Map, { Marker, Popup, NavigationControl } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import $ from "jquery";

const MAPBOX_TOKEN =
  "pk.eyJ1IjoiYWJkZWFsaTcyIiwiYSI6ImNsN2J6ZWh4eDE3OXgzcW84d2VxbWRpM24ifQ.RnphYbegeMvk3I1fjTqY5g"; // move to env later

const OurNetwork = () => {
  MoveCursorToTop();

  const [location, setLocation] = useState([]);
  const [data, setData] = useState(null);

  const fetchLocation = useCallback(async (value) => {
    await callApi(CommonApi.getLocation.method, CommonApi.getLocation.url, value, null, defaultHeader())
      .then((res) => {
        if (!res?.data?.error) {
          const payload = res?.data?.data || [];
          const arr = payload.map((p) => ({
            id: p?.id,
            title: p?.title,
            description: p?.description,
            maps: p?.maps,
            address: p?.address,
            contact_info: validateJsonString(p?.contact_info),
          }));
          setLocation(arr);
          $(".in-svg").ready(() => image2svg());
        }
      })
      .catch((err) => {
        console.log(err);
        toastError(err?.response?.data?.message);
      });
  }, []);

  const fetchData = useCallback(async () => {
    await callApi(CommonApi.getSettings.method, CommonApi.getSettings.url, null, null, defaultHeader())
      .then((res) => {
        if (!res?.data?.error) {
          const payload = res?.data?.data || [];
          const item = payload.find((p) => p?.key_name === "our-network");
          if (item) setData(item.key_value);
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    fetchData();
    fetchLocation(1);
    AOS.init();
    AOS.refresh();
  }, []);

  const onLocationChange = useCallback((e) => {
    fetchLocation(e.target.value);
  }, []);

  // popup toggles
  const [showGhubra, toggleGhubra] = useState(false);
  const [showWataya, toggleWataya] = useState(false);
  const [showIbri, toggleIbri] = useState(false);
  const [showNizwa, toggleNizwa] = useState(false);
  const [showSalah1, toggleSalah1] = useState(false);
  const [showSohar, toggleSohar] = useState(false);
  const [showSur, toggleSur] = useState(false);
  const [showMabela, toggleMabela] = useState(false);

  const closeAll = () => {
    toggleGhubra(false);
    toggleWataya(false);
    toggleIbri(false);
    toggleNizwa(false);
    toggleSalah1(false);
    toggleSohar(false);
    toggleSur(false);
    toggleMabela(false);
  };

  // react-map-gl view state replaces center/zoom arrays
  const [viewState, setViewState] = useState({
    longitude: 54.424,
    latitude: 21.591,
    zoom: 5,
  });

  return (
    <>
      <section className="hero__banner--block our-networks">
        <div className="hero__banner--img centered-img-wrapper" data-aos="fade-down" data-aos-duration="1300">
          <img
            className="lazy-load centered-img"
            src={`${urls.dir_url}/${data || ""}`}
            width="1920"
            height="1172"
            alt="Hero Banner"
          />
        </div>
        <div className="page__title">
          <h2 className="h6 text-uppercase text-white mb-0">Our Network</h2>
        </div>
      </section>

      <section className="our_network--block">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="our_network__box">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="our_network__list">
                      <div className="form-group">
                        <select name="types" className="form-control bg-white" onChange={onLocationChange}>
                          <option value="1">Sales</option>
                          <option value="2">Service & Parts</option>
                          {/* <option value="3">Multi Franchise Mega Body Shop</option> */}
                          {/* <option value="4">MCRC-SIXT Rent-a-Car</option> */}
                        </select>
                      </div>

                      <div className="location__list pt-4">
                        <div className="row">
                          {location.length > 0 &&
                            location
                              .filter((l) => l?.title !== "GHUBRA" && l?.title !== "SALALAH")
                              .map((l, i) => (
                                <div className="col-md-6" key={l.id ?? i}>
                                  <div className="location__item card">
                                    <div className="card-header">
                                      <a href={l?.maps} target="_blank" rel="noreferrer">
                                        <h4 className="h6 text-uppercase text-white mb-0 d-flex align-items-center">
                                          <img className="in-svg" src={`${urls.frontendUrl}/images/pin.svg`} alt="Map Pin" /> <span>{l?.title}</span>
                                        </h4>
                                      </a>
                                    </div>
                                    <div className="card-body">
                                      <address>
                                        <span dangerouslySetInnerHTML={{ __html: l?.description }} />
                                      </address>
                                      <address>
                                        <span dangerouslySetInnerHTML={{ __html: l?.address }} />
                                      </address>
                                      <ul className="list-unstyled">
                                        {Array.isArray(l?.contact_info) &&
                                          l.contact_info.map((c, j) => (
                                            <li key={`ci-${i}-${j}`}>
                                              <h5 className="mb-1 text-uppercase">{c?.title}</h5>
                                              {Array.isArray(c?.phone) &&
                                                c.phone.map((p, k) => (
                                                  <a key={`ph-${i}-${j}-${k}`} href={`tel:${p}`} style={{ display: "block" }}>
                                                    {p}
                                                  </a>
                                                ))}
                                            </li>
                                          ))}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              ))}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="tool__free text-center mb-5">
                      <a href="tel:80076200">
                        <img className="in-svg" src={`${urls.frontendUrl}/images/toll-free-icon.svg`} alt="Toll Free" /> 80076200
                      </a>
                    </div>

                    <div className="our_network__map centered-img-wrapper">
                      <Map
                        {...viewState}
                        onMove={(evt) => setViewState(evt.viewState)}
                        mapStyle="mapbox://styles/mapbox/streets-v12"
                        mapboxAccessToken={MAPBOX_TOKEN}
                        style={{ height: "60vh", width: "100%" }}
                        onClick={() => closeAll()}
                      >
                        <NavigationControl position="top-right" />

                        {/* Popups */}
                        {showGhubra && (
                          <Popup longitude={58.4247957} latitude={23.5913749} anchor="top" closeOnClick={false} onClose={() => toggleGhubra(false)}>
                            <div style={{ marginTop: -6 }}>
                              SATURDAY – THURSDAY : 8:30AM-1PM | 4PM-8PM
                              <br />
                              BUILDING # 215, WAY # 3701 NEAR BAUSHER MUNICIPALITY, MUSCAT
                              <br />
                              <h6>GMC</h6>
                              +968 22080863
                              <br />
                              80076200
                            </div>
                          </Popup>
                        )}

                        {showWataya && (
                          <Popup longitude={58.5192137} latitude={23.6005173} anchor="top" closeOnClick={false} onClose={() => toggleWataya(false)}>
                            <div style={{ marginTop: -6 }}>
                              SATURDAY – THURSDAY : 8:30AM-1PM | 4PM-8PM
                              <br />
                              MUSCAT MUSCAT
                              <br />
                              <h6>SUZUKI</h6>
                              +968 24571110
                              <br />
                              80076200
                            </div>
                          </Popup>
                        )}

                        {showIbri && (
                          <Popup longitude={56.4976005} latitude={23.2188186} anchor="top" closeOnClick={false} onClose={() => toggleIbri(false)}>
                            <div style={{ marginTop: -6 }}>
                              SATURDAY – THURSDAY : 8:30AM-1PM | 4PM-8PM
                              <br />
                              PLAT # 552, IBRI TOWN, AL NAHDA MAIN ROAD
                              <br />
                              <h6>GMC</h6>
                              +968 94291472
                              <br />
                              +968 25692287
                              <br />
                              <h6>SUZUKI</h6>
                              +968 98160081
                              <br />
                              +968 95349302
                            </div>
                          </Popup>
                        )}

                        {showNizwa && (
                          <Popup longitude={57.5332707} latitude={22.9019717} anchor="top" closeOnClick={false} onClose={() => toggleNizwa(false)}>
                            <div style={{ marginTop: -6 }}>
                              SATURDAY – THURSDAY : 8:30AM-1PM | 4PM-8PM
                              <br />
                              SHOWROOM ROAD, NEAR OMAN OIL PETROL PUMP
                              <br />
                              <h6>GMC</h6>
                              +968 95548386
                              <br />
                              +968 25413082
                              <br />
                              <h6>SUZUKI</h6>
                              +968 95755468
                              <br />
                              +968 25413082
                            </div>
                          </Popup>
                        )}

                        {showSalah1 && (
                          <Popup longitude={54.0474039} latitude={17.0181901} anchor="top" closeOnClick={false} onClose={() => toggleSalah1(false)}>
                            <div style={{ marginTop: -6 }}>
                              SATURDAY – THURSDAY : 8:30AM-1PM | 4PM-8PM
                              <br />
                              PLOT # 80 NEAR ZAINAB MOSQUE, AWQAD INDUSTRIAL AREA
                              <br />
                              <h6>GMC</h6>
                              +968 94054347
                              <br />
                              +968 23211028
                            </div>
                          </Popup>
                        )}

                        {showSohar && (
                          <Popup longitude={56.7483556} latitude={24.3218842} anchor="top" closeOnClick={false} onClose={() => toggleSohar(false)}>
                            <div style={{ marginTop: -6 }}>
                              SATURDAY – THURSDAY : 8:30AM-1PM | 4PM-8PM
                              <br />
                              BLDG. NUMBER: 289, PLOT NUMBER: 17 AL GHAIL RD, NEAR R&B AND SHELL PETROL PUMP
                              <br />
                              <h6>GMC</h6>
                              +968 95658473
                              <br />
                              +968 26840379
                              <br />
                              <h6>Suzuki</h6>
                              +968 94291465
                              <br />
                              +968 26840379
                            </div>
                          </Popup>
                        )}

                        {showSur && (
                          <Popup longitude={59.492794} latitude={22.5611129} anchor="top" closeOnClick={false} onClose={() => toggleSur(false)}>
                            <div style={{ marginTop: -6 }}>
                              SATURDAY – THURSDAY : 8:30AM-1PM | 4PM-8PM
                              <br />
                              BILAD
                              <br />
                              <h6>GMC</h6>
                              +968 99224722
                              <br />
                              +968 25541797
                              <br />
                              <h6>Suzuki</h6>
                              +968 99224722
                              <br />
                              +968 25541797
                            </div>
                          </Popup>
                        )}

                        {showMabela && (
                          <Popup longitude={58.0984508} latitude={23.6597786} anchor="top" closeOnClick={false} onClose={() => toggleMabela(false)}>
                            <div style={{ marginTop: -6 }}>
                              SUNDAY – THURSDAY : 8:00AM-1PM | 3:30PM-7PM
                              <br />
                              SATURDAY: 8:00AM-1PM (MABELLA CLOSED)
                              <br />
                              BUILDING # 11595, WAY # 7768
                              <h6>Service</h6>
                              +968 95349249
                              <br />
                              <h6>Parts</h6>
                              +968 94761716
                              <br />
                              +968 24450161
                            </div>
                          </Popup>
                        )}

                        {/* Markers */}
                        <Marker
                          longitude={58.5192137}
                          latitude={23.6005173}
                          onClick={(e) => {
                            e.originalEvent.stopPropagation();
                            closeAll();
                            toggleWataya(true);
                          }}
                        >
                          <img src="https://moosagroup.com/frontend/public/images/mapicon.png" alt="pin" style={{ height: 24, width: 24 }} />
                        </Marker>

                        <Marker
                          longitude={56.4976005}
                          latitude={23.2188186}
                          onClick={(e) => {
                            e.originalEvent.stopPropagation();
                            closeAll();
                            toggleIbri(true);
                          }}
                        >
                          <img src="https://moosagroup.com/frontend/public/images/mapicon.png" alt="pin" style={{ height: 24, width: 24 }} />
                        </Marker>

                        <Marker
                          longitude={57.5332707}
                          latitude={22.9019717}
                          onClick={(e) => {
                            e.originalEvent.stopPropagation();
                            closeAll();
                            toggleNizwa(true);
                          }}
                        >
                          <img src="https://moosagroup.com/frontend/public/images/mapicon.png" alt="pin" style={{ height: 24, width: 24 }} />
                        </Marker>

                        <Marker
                          longitude={56.7483556}
                          latitude={24.3218842}
                          onClick={(e) => {
                            e.originalEvent.stopPropagation();
                            closeAll();
                            toggleSohar(true);
                          }}
                        >
                          <img src="https://moosagroup.com/frontend/public/images/mapicon.png" alt="pin" style={{ height: 24, width: 24 }} />
                        </Marker>

                        <Marker
                          longitude={59.492794}
                          latitude={22.5611129}
                          onClick={(e) => {
                            e.originalEvent.stopPropagation();
                            closeAll();
                            toggleSur(true);
                          }}
                        >
                          <img src="https://moosagroup.com/frontend/public/images/mapicon.png" alt="pin" style={{ height: 24, width: 24 }} />
                        </Marker>

                        <Marker
                          longitude={58.0984508}
                          latitude={23.6597786}
                          onClick={(e) => {
                            e.originalEvent.stopPropagation();
                            closeAll();
                            toggleMabela(true);
                          }}
                        >
                          <img src="https://moosagroup.com/frontend/public/images/mapicon.png" alt="pin" style={{ height: 24, width: 24 }} />
                        </Marker>
                      </Map>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OurNetwork;
